export default {

    isEqual(field,value, compareInt){  
    
        const samevalue = value.some(obj=> parseInt(obj[field]) === parseInt(compareInt) )
        console.log('sameValue',samevalue)
        console.log('compareInt',compareInt)
         return  samevalue
    },

    inValidRange(field,value,compareInt){
        const highest = Math.max(
            ...this.policiesItems.map((item) => item.minPrice)
          )
       
    },

 
  

    isDocument(value) {
        value = value.replace(/[^0-9]/g, "");
        switch (value.length) {
            case 11:
                return this.isCPF(value)
            case 14:
                return this.isCNPJ(value)
            default:
                return false
        }

    },
    isCNPJ(value) {
        let cnpj = value.replace(/[^\d]+/g, '');

        if (cnpj == '') return false;

        if (cnpj.length != 14)
            return false;

        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" ||
            cnpj == "11111111111111" ||
            cnpj == "22222222222222" ||
            cnpj == "33333333333333" ||
            cnpj == "44444444444444" ||
            cnpj == "55555555555555" ||
            cnpj == "66666666666666" ||
            cnpj == "77777777777777" ||
            cnpj == "88888888888888" ||
            cnpj == "99999999999999")
            return false;

        // Valida DVs
        let tamanho = cnpj.length - 2
        let numeros = cnpj.substring(0, tamanho);
        let digitos = cnpj.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;

        return true;
    },
    isCPF(value) {
        value = value.replace(/[^0-9]/g, "")
        if (value.length != 11 ||
            value == "00000000000" ||
            value == "11111111111" ||
            value == "22222222222" ||
            value == "33333333333" ||
            value == "44444444444" ||
            value == "55555555555" ||
            value == "66666666666" ||
            value == "77777777777" ||
            value == "88888888888" ||
            value == "99999999999")
            return false;

        let add = 0;

        for (let i = 0; i < 9; i++)
            add += parseInt(value.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(value.charAt(9)))
            return false;
        add = 0;
        for (let i = 0; i < 10; i++)
            add += parseInt(value.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(value.charAt(10)))  
            return false;
        return true;
    },
    // isValidPeruRUC(value) {
    //     let ruc = value.replace(/[-.,[\]()\s]+/g, "")
        
    //     if (ruc.length !== 11) {
    //         console.log('ruc menor que 11',ruc.length)
    //         return false;
    //       }
    //       const firstDigit = parseInt(ruc[0]);
    //       if (firstDigit < 1 || firstDigit > 2) {
    //         console.log('ruc menor que 1 ou maior que 2')
    //         return false;
    //       }
    //       if (firstDigit === 2 && parseInt(ruc[1]) !== 0) {
    //         console.log('ruc e igual a 2 mas o segundo número é diferente de ')
    //         return false;
    //       }

    //       const coefficients = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    //       const digits = ruc.split('').map(Number);
    //       const verifier = parseInt(ruc[10]);
    //       const sum = coefficients.reduce((acc, coef, index) => acc + coef * digits[index], 0);
    //       const remainder = sum % 11;
    //       const calculatedDigit = remainder === 0 ? 0 : 11 - remainder;
        
    //       return verifier === calculatedDigit;
        
    // }
    isValidPeruRUC(value) {
        let ruc = value.replace(/[-.,[\]()\s]+/g, "")
        if ((ruc = Number(ruc)) && ruc % 1 === 0
        ) {
            if (!(ruc >= 1e10 && ruc < 11e9
                || ruc >= 15e9 && ruc < 18e9
                || ruc >= 2e10 && ruc < 21e9)) {
                return false;
            }

            for (var suma = -(ruc % 10 < 2), i = 0; i < 11; i++, ruc = ruc / 10 | 0)
                suma += (ruc % 10) * (i % 7 + (i / 7 | 0) + 1);
            
            return suma % 11 === 0 ? true : false;
        } else {
            return false
        }
    },
    isCompanyPeruRuc(value){
        console.log('value to test ruc', value)
        return value.startsWith("20");
    }
}